// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./App.css";
import { LanguageProvider } from "./i18n";
import ScrollToTop from "./components/ScrollToTop";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename="/">
    <LanguageProvider>
      <ScrollToTop />
      <App />
    </LanguageProvider>
  </BrowserRouter>
);